// Todo o texto do site fica aqui, para facilitar a edição sem mexer no layout.

export const contato = {
  nome: 'Ana Caroline Almeida',
  nomeCompleto: 'Ana Caroline Correia de Almeida de Jesus',
  titulo: 'Psicóloga clínica e perinatal',
  crp: 'CRP 03/11502',
  telefoneExibicao: '(71) 99188-7375',
  telefoneLink: '5571991887375',
  email: 'carolinealmeida.c@gmail.com',
  linkedin: 'https://www.linkedin.com/in/ana-caroline-almeida-8313a880/',
  instagram: 'psi_anaalmeida',
};

const mensagemWhatsApp = 'Olá, Ana Caroline! Vim pelo site e gostaria de agendar uma consulta.';

export const linkWhatsApp = `https://wa.me/${contato.telefoneLink}?text=${encodeURIComponent(mensagemWhatsApp)}`;

export const destaques = [
  'Atendimento online por videochamada',
  'Sessões semanais de 40 minutos',
  'Para todo o Brasil e o exterior',
];

export const sobre = {
  paragrafos: [
    'Sou psicóloga e psicoterapeuta, com especialização em Saúde da Família e em Psicologia Perinatal.',
    'Atuo como psicóloga clínica no atendimento individual de adolescentes e adultos, na modalidade online, para todo o Brasil e para quem mora no exterior. Acompanho as mais diversas demandas, como transtornos ansiosos, depressão, fobias, conflitos profissionais, transtorno bipolar, transtornos alimentares e traumas psicológicos, entre outras.',
    'No processo terapêutico, os objetivos de cada paciente são respeitados: é um trabalho único e personalizado, que busca desenvolver as habilidades necessárias para superar medos, dificuldades e dores que limitam emocionalmente, além de promover o autoconhecimento e fortalecer a autoestima. Assim, é possível ressignificar a própria história e restabelecer o equilíbrio psicológico.',
  ],
  formacao: [
    { titulo: 'Psicóloga clínica', detalhe: 'CRP 03/11502' },
    { titulo: 'Especialização em Psicologia Perinatal', detalhe: 'Gestação, tentantes e parentalidade' },
    { titulo: 'Especialização em Saúde da Família', detalhe: '' },
    { titulo: 'Atendimento online', detalhe: 'Adolescentes e adultos, no Brasil e no exterior' },
  ],
  citacao: {
    texto: 'A terapia começa antes mesmo do terapeuta. Quando a pessoa percebe que algo precisa ser mudado, já é parte do processo.',
    autor: 'Ricardo Furtado',
  },
};

export const especialidades = [
  {
    titulo: 'Psicoterapia individual',
    descricao: 'Acompanhamento semanal para adultos e adolescentes a partir dos 12 anos.',
  },
  {
    titulo: 'Psicoterapia perinatal',
    descricao: 'Atendimento especializado para gestantes, tentantes e pais, da gestação ao pós-parto.',
  },
  {
    titulo: 'Avaliação psicológica',
    descricao: 'Aplicação de testes psicológicos para coletar dados, levantar hipóteses diagnósticas e indicar o tratamento mais adequado.',
  },
  {
    titulo: 'Avaliação para cirurgia bariátrica',
    descricao: 'Avaliação da preparação emocional para a cirurgia, com suporte e cuidado também no pós-operatório.',
  },
  {
    titulo: 'Psicoterapia com foco no emagrecimento',
    descricao: 'Para quem encontra dificuldade em perder peso por questões emocionais, como compulsão e ansiedade.',
  },
  {
    titulo: 'Orientação profissional',
    descricao: 'Compreensão de aptidões, interesses e dificuldades envolvidos na escolha de uma profissão.',
  },
];

export const passos = [
  { titulo: 'Entre em contato', descricao: 'Envie uma mensagem pelo WhatsApp contando que deseja agendar.' },
  { titulo: 'Escolha o horário', descricao: 'Combinamos juntos o dia e o horário que funcionam melhor para você.' },
  { titulo: 'Faça o pagamento', descricao: 'Por Pix, transferência ou boleto, até 4 horas antes da sessão.' },
  { titulo: 'Receba a confirmação', descricao: 'Você recebe a confirmação do atendimento e está tudo pronto.' },
];

export const preparacao = [
  'Use fones de ouvido e tenha uma boa conexão de internet.',
  'Escolha um lugar confortável, silencioso e privado. Para preservar o sigilo, não é permitida a participação de terceiros.',
  'Se houver falha de conexão, a sessão é reagendada sem custo adicional.',
];

export const perguntas = [
  {
    pergunta: 'Como funciona o atendimento online?',
    resposta: 'O atendimento online é regulamentado pelo Conselho Federal de Psicologia e tem a mesma eficácia do presencial, como diversos estudos já demonstraram. As sessões acontecem uma vez por semana, com 40 minutos de duração, por videochamada no WhatsApp, no horário agendado. A ética, o sigilo e as técnicas utilizadas são os mesmos do consultório presencial.',
  },
  {
    pergunta: 'Quais são os benefícios do atendimento online?',
    resposta: 'Você pode fazer a terapia no conforto de casa ou do escritório, com mais flexibilidade de horários e sem perder tempo com deslocamento e trânsito. Além disso, é possível ser atendido de qualquer cidade do Brasil ou do exterior.',
  },
  {
    pergunta: 'Atende pelo plano de saúde?',
    resposta: 'Não. O atendimento é somente particular. Para saber valores e pacotes com desconto, entre em contato pelo WhatsApp.',
  },
  {
    pergunta: 'Quais são as formas de pagamento?',
    resposta: 'O pagamento pode ser feito por Pix, transferência ou boleto bancário, até 4 horas antes do horário agendado.',
  },
];
